import React from 'react';
import ReactDOM from 'react-dom';
import { Icon } from 'semantic-ui-react';
import './ProcessingModal.css';

const ProcessingModal = ({ 
  isOpen, 
  title = 'Processing...',
  message = 'Please wait...',
  icon = 'cog',
  progress = null,
  creditBalance = null,
  creditsUsed = 1,
  tip = null
}) => {
  if (!isOpen) return null;

  const remainingCredits = creditBalance !== null ? Math.max(0, creditBalance - creditsUsed) : null;

  const modalContent = (
    <div className="processing-modal-overlay">
      <div className="processing-modal">
        <div className="processing-modal-content">
          <div className="processing-spinner">
            <div className="spinner-ring"></div>
            <div className="spinner-inner">
              <span className="processing-icon">
                <Icon name={icon} style={{ margin: 0, fontSize: '28px', color: '#00b5ad' }} />
              </span>
            </div>
          </div>
          
          <h3 className="processing-title">{title}</h3>
          <p className="processing-message">{message}</p>
          
          {creditBalance !== null && (
            <div className="processing-credits">
              <span className="credits-used">Credits used: {creditsUsed}</span>
              <span className="credits-remaining">Remaining: {remainingCredits}</span>
            </div>
          )}
          
          {progress !== null && (
            <div className="processing-progress">
              <div className="progress-bar">
                <div 
                  className="progress-fill" 
                  style={{ width: `${Math.max(10, progress)}%` }}
                ></div>
              </div>
              <span className="progress-text">{Math.round(progress)}%</span>
            </div>
          )}
          
          {tip && (
            <div className="processing-tips">
              <p><Icon name="magic" size="small" style={{ marginRight: '4px' }} />{tip}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ProcessingModal;

